import styled, { css } from 'styled-components';
import ReactSlider, { ReactSliderProps } from 'react-slider';
import React, { useState } from 'react';
import { theme } from './style';

import { useCovideoTheme } from 'react-covideo-common';

const StyledSlider = styled(ReactSlider)<{ width?: string }>`
  width: ${({ width }) => width || 'auto'};
  height: 6px;
  border-radius: 6px;
  ${theme.mediaQueryMaxWidth.md} {
    width: 100%;
  }
`;

const StyledThumb = styled.div<{
  isdragging?: string;
  primary: { 100: string; 10: string };
}>`
  height: 16px;
  width: 16px;
  text-align: center;
  background-color: ${({ primary }) => primary[100]};
  color: ${({ primary }) => primary[100]};
  border: 2px solid ${theme.palette.white};
  border-radius: 50%;
  cursor: grab;
  top: 50%;
  transform: translateY(-50%);
  box-shadow: 0 3px 10px rgb(0 0 0 / 0.2);
  ${({ isdragging, primary }) =>
    isdragging === 'true' &&
    css`
      box-shadow: 0px 0px 0px 6px ${primary[10]};
    `}
  &:hover {
    box-shadow: ${({ primary }) => `0px 0px 0px 6px ${primary[10]};`}
  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
  }
`;

const StyledMark = styled.div`
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background-color: ${theme.palette.gray40};
  transform: translateX(7px);
  cursor: pointer;
`;

const StyledTrack = styled.div`
  top: 0;
  bottom: 0;
  background: ${theme.palette.gray10};
  border-radius: 999px;
`;

type StyledSliderProps = Omit<
  ReactSliderProps,
  'renderTrack' | 'renderThumb'
> & {
  width?: string;
};

export const Slider = (props: StyledSliderProps) => {
  const covideoTheme = useCovideoTheme();
  const [isDragging, setIsDragging] = useState(false);
  const handleBeforeChange = () => {
    setIsDragging(true);
  };
  const handleAfterChange = () => {
    setIsDragging(false);
  };
  return (
    <StyledSlider
      // any because render component props not available
      {...(props as any)}
      onBeforeChange={handleBeforeChange}
      onAfterChange={handleAfterChange}
      renderTrack={(props: any) => <StyledTrack {...props} />}
      renderMark={(props: any) => <StyledMark {...props} />}
      renderThumb={(props: any) => (
        <StyledThumb
          isdragging={`${isDragging}`}
          primary={covideoTheme.colors.primary}
          {...props}
        />
      )}
      width={props.width}
    />
  );
};
